import React, {
    // ReactNode,
    // useRef,
    useState,
} from 'react'
import { VkOrdHistoryResponse } from '@synapex/shared2/gateway-rest-api'

import {
    TABLE_COLUMNS_LAYOUT,
    type TableReactNodeRecord,
} from './tableColumnsLayout'
import { TableRow } from './TableRow'
import classes from './Table.module.scss'

const useTableHeight = () => {
    // const tableRef = useRef<HTMLTableElement>(null)

    // const { height } = useResizeObserver({ ref: tableRef })

    const [height, setHeight] = useState(180)

    const tableRef = (el: HTMLTableElement | null) => {
        if (el && el.scrollHeight !== height) {
            setHeight(el.scrollHeight)
        }
    }

    return {
        tableRef,
        tableWrapperStyle: {
            '--table-height': `${height}px`,
        } as React.CSSProperties,
    }
}

export type TableProps = {
    vkOrdHistory: VkOrdHistoryResponse[]
}

export const Table = ({ vkOrdHistory }: TableProps) => {
    const { tableRef, tableWrapperStyle } = useTableHeight()

    const tableRow: TableReactNodeRecord = {
        typeText: <>Тип действия</>,
        lastUpdate: <>Последнее обновление</>,
        status: <>Статус</>,
        description: <>Описание результата</>,
        id: <>ID</>,
    }

    return (
        <div className={classes.tableWrapper} style={tableWrapperStyle}>
            <div className={classes.tableScroll}>
                <table ref={tableRef}>
                    <thead>
                        <tr>
                            {TABLE_COLUMNS_LAYOUT.map(
                                ({ key, style, className }) => (
                                    <th
                                        key={key}
                                        style={style}
                                        className={className}
                                    >
                                        {tableRow[key]}
                                    </th>
                                )
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {vkOrdHistory.map((item) => (
                            <TableRow key={item.externalId} data={item} />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
